/** `[[lesson:M22-L02]]` in an agent message → a lesson card (SUN-110c). The token itself is never shown. */
const TOKEN = /\[\[lesson:([A-Za-z0-9._-]{1,40})\]\]/g;
const NOT_MY_ROLE = /not part of your role/i;

export function lessonIdsIn(text: string): string[] {
  return [...new Set([...text.matchAll(TOKEN)].map((m) => m[1]))];
}

export function stripLessonTokens(text: string): string {
  return text.replace(TOKEN, '').replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
}

/** The reply says the lesson is not for this role ("Send to admin" is offered). */
export function saysNotMyRole(text: string): boolean {
  return NOT_MY_ROLE.test(text);
}
